import { z } from 'zod'
import { Model } from '../../_kernel/architecture'
import { Name } from '../../_kernel/Name'
import { Path } from '../../_kernel/Path'
import { AncillaryType } from './AncillaryType'

export const AncillaryValidation = z.object({
  type: z.instanceof(AncillaryType, { message: 'type is required' }),
  link: z.instanceof(Path, { message: 'link is required' }),
  titleKey: z.instanceof(Name, { message: 'titleKey is required' }).optional(),
  bodyKey: z.instanceof(Name, { message: 'bodyKey is required' }).optional(),
  ctaKey: z.instanceof(Name, { message: 'ctaKey is required' }).optional(),
  imageSrc: z.instanceof(Path, { message: 'imageSrc is required' }).optional(),
})

export class Ancillary extends Model {
  static create({
    type,
    link,
    titleKey,
    bodyKey,
    ctaKey,
    imageSrc,
  }: z.infer<typeof AncillaryValidation>) {
    AncillaryValidation.parse({ type, link, titleKey, bodyKey, ctaKey, imageSrc })
    return new Ancillary(type, link, titleKey, bodyKey, ctaKey, imageSrc)
  }

  static fromJSON(json: ReturnType<Ancillary['toJSON']>) {
    return Ancillary.create({
      type: AncillaryType.create({ value: json.type }),
      link: Path.create({ value: json.link }),
      ...(json.titleKey && { titleKey: Name.create({ value: json.titleKey }) }),
      ...(json.bodyKey && { bodyKey: Name.create({ value: json.bodyKey }) }),
      ...(json.ctaKey && { ctaKey: Name.create({ value: json.ctaKey }) }),
      ...(json.imageSrc && { imageSrc: Path.create({ value: json.imageSrc }) }),
    })
  }

  constructor(
    private readonly _type: AncillaryType,
    private readonly _link: Path,
    private readonly _titleKey?: Name,
    private readonly _bodyKey?: Name,
    private readonly _ctaKey?: Name,
    private readonly _imageSrc?: Path
  ) {
    super()
  }

  get type() { return this._type.value } // prettier-ignore
  get link() { return this._link.value } // prettier-ignore
  get titleKey() { return this._titleKey?.value ?? null } // prettier-ignore
  get bodyKey() { return this._bodyKey?.value ?? null } // prettier-ignore
  get ctaKey() { return this._ctaKey?.value ?? null } // prettier-ignore
  get imageSrc() { return this._imageSrc?.value ?? null } // prettier-ignore

  toJSON() {
    return {
      type: this.type,
      link: this.link,
      titleKey: this.titleKey,
      bodyKey: this.bodyKey,
      ctaKey: this.ctaKey,
      imageSrc: this.imageSrc,
    }
  }
}
